export const SYSTEM_USER = {
    LOGIN: 'system',
    UID: 'systemId',
};
